import { useLanguage } from "../lang/LanguageContext";
import { HiMiniAcademicCap } from "react-icons/hi2";

export default function InfoGrid() {
  const { strings } = useLanguage();

  return (
    <section className="mt-12 px-6 max-w-4xl mx-auto text-white">
      <div className="grid md:grid-cols-2 gap-6">
        {/* Interests */}
        <div className="border rounded-xl p-6 shadow hover:shadow-md transition">
          <h3 className="text-xl font-semibold mb-2">{strings.sections.interests.title}</h3>
          <ul className="list-disc list-inside text-blue-100 space-y-1">
            {strings.sections.interests.items.map((item, index) => (
            <li key={index}>{item}</li>
            ))}
          </ul>
        </div>

        {/* Education */}
        <div className="border rounded-xl p-6 shadow hover:shadow-md transition">
          <h3 className="text-xl font-semibold mb-2">{strings.sections.education.title}</h3>
          <ul className="space-y-1 text-blue-100">
            {strings.sections.education.items.map((item, index) => (
            <li key={index} className="flex items-start">
              <HiMiniAcademicCap className="mr-2 mt-1" style={{ width: 18, height: 18, minWidth: 18 }} />
            <span>{item}</span>
            </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
